import React, { Component } from "react";
import { NavBar, SideBar, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import clienteModel from "../../models/cliente";
//import historicoFaturamentoModel from "../../models/historicoFaturamento";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatarReal } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AsyncSelect from "react-select/async";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "debounce-promise";
PouchDB.plugin(PouchdbFind);

class HistoricoVenda extends Component {
  constructor(props) {
    super(props);
    this.handleChangeCliente = this.handleChangeCliente.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeQueryBusca = this.onChangeQueryBusca.bind(this);
    this.buscarItens = this.buscarItens.bind(this);
    this.filtrarItens = this.filtrarItens.bind(this);
    this.notificar = this.notificar.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.transformDataComboBoxCliente =
      this.transformDataComboBoxCliente.bind(this);
    this.filtrar = this.filtrar.bind(this);
    this.gerarDanfe = this.gerarDanfe.bind(this);

    this.debouncedLoadOptions = debounce(
      (inputValue) => this.promiseOptions(inputValue),
      500,
      {
        leading: true,
      }
    );

    this.state = {
      clientes: [],
      clienteSelecionado: null,
      startDate: new Date(),
      dataInicial: new Date(),
      dataFinal: new Date(),
      busca: "",
      itens: [],
      itensBkp: [],
      exibirLoading: false,
      skip: 0,
    };
  }

  async componentDidMount() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    this.setState({ db });
  }

  handleChangeCliente(clienteSelecionado) {
    this.setState(
      {
        clienteSelecionado,
      },
      () => {
        this.setState({
          itens: [],
          itensBkp: [],
          skip: 0,
          hasMore: true,
        });
      }
    );
  }

  onChangeDate(tipo, agt) {
    this.setState({ [tipo]: agt });
  }

  onChangeQueryBusca(busca) {
    this.setState({ busca }, () => this.filtrarItens());
  }

  async filtrar(exibirLoading = true) {
    if (this.state.clienteSelecionado === null) {
      this.notificar("warning", "Selecione o cliente");
      return false;
    }

    this.setState({ exibirLoading: exibirLoading }, async () => {
      let itens = await this.buscarItens();
      let itensBkp = [].concat(itens);
      let hasMore = true;
      if (itens.length === 0 && this.state.itensBkp.length === 0) {
        this.notificar("warning", "Sua busca não retornou nenhum resultado.");
        hasMore = false;
      } else {
        if (this.state.busca !== "") {
          let busca = this.state.busca.toUpperCase();
          itens = itens.filter((item) => {
            if (item.idIntegracao.toString().search(busca.toString()) !== -1) {
              return true;
            }
            if (item.desc.search(busca) !== -1) {
              return true;
            }
            return false;
          });
        }
      }

      if (itens.length === 0) {
        hasMore = false;
      }

      this.setState(
        {
          itens: this.state.itens.concat(itens),
          itensBkp: this.state.itensBkp.concat(itensBkp),
          hasMore,
          skip: this.state.skip + 5,
        },
        () => {
          this.setState({ exibirLoading: false });
        }
      );
    });
  }

  async buscarItens() {
    let obj = {
      cliente: this.state.clienteSelecionado.idIntegracao,
      dtInicio: this.state.dataInicial,
      dtFinal: this.state.dataFinal,
      skip: this.state.skip,
    };
    let itens = [];
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/historico-faturamento`,
        obj,
        this.props.parameters()
      )
      .then((response) => {
        itens = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      })
    return itens;
  }
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> REVER LÓGICA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  async filtrarItens() {
    let itens = this.state.itensBkp;
    let busca = this.state.busca.toUpperCase();
    itens = itens.filter((item) => {
      if (item.cod.toString().search(busca.toString()) !== -1) {
        return true;
      }
      if (item.desc.search(busca) !== -1) {
        return true;
      }
      return false;
    });

    this.setState({ itens });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          let clientes = [];
          // let clientes = await clienteModel.findAll(this.state.db);
          clientes = this.transformDataComboBoxCliente(clientes);
          this.setState({ clientes });

          resolve(clientes);
        } else {
          let aux = inputValue.substr(0, 1);
          let len = 2;
          if (aux == "&" || aux == "%") len = 3;
          if (inputValue.length >= len) {
            let clientes = await clienteModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            clientes = this.transformDataComboBoxCliente(clientes);
            this.setState({ clientes });
            resolve(clientes);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.descFormat;
      item.label = item.descFormat;
      return item;
    });
    return lista;
  }

  async gerarDanfe() {
    let parametros = {};

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/gerar-danfe`,
        { parametros }
      )
      .then(async (response) => {
        localStorage.setItem("htmlDanfe", response.data.html);
        localStorage.setItem("tituloPaginaDanfe", `Visualizar Danfe`);
        window.open("/visualizador-danfe", "_blank");
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          // this.notificar("warning", error.response.data.erro);
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Histórico de Faturamento por Item" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"historicoVenda"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Histórico de Vendas"
                  description="Consultar histórico de vendas"
                /> */}
                <div id="container-historico-vendas">
                  <div className="container card">
                    <div className="row" style={{ padding: "0px 15px" }}>
                      <div className="form-group col-5 pd-pedido">
                        <label className="font-size-14">Cliente</label>
                        <AsyncSelect
                          cacheOptions
                          defaultOptions
                          loadOptions={(inputValue) =>
                            this.debouncedLoadOptions(inputValue)
                          }
                          value={this.state.clienteSelecionado}
                          onChange={(item) => this.handleChangeCliente(item)}
                          placeholder="Pesquise pela fantasia ou código"
                          className="font-size-14"
                        />
                      </div>

                      <div className="form-group col-3 pd-pedido">
                        <label>Data Inicial</label>
                        <DatePicker
                          selected={this.state.dataInicial}
                          withPortal
                          customInput={
                            <input className="form-control font-size-13" />
                          }
                          dateFormat="dd/MM/yyyy"
                          onChange={(date) =>
                            this.onChangeDate("dataInicial", date)
                          }
                          locale="pt-BR"
                        />
                      </div>

                      <div className="form-group col-3 pd-pedido">
                        <label>Data Final</label>
                        <DatePicker
                          selected={this.state.dataFinal}
                          withPortal
                          customInput={
                            <input className="form-control font-size-13" />
                          }
                          dateFormat="dd/MM/yyyy"
                          onChange={(date) =>
                            this.onChangeDate("dataFinal", date)
                          }
                          locale="pt-BR"
                        />
                      </div>

                      <div className="form-group col-1 pd-pedido">
                        <div
                          className=""
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#434343",
                            fontSize: "25px",
                            cursor: "pointer",
                            marginTop: "29px",
                          }}
                          onClick={this.filtrar}
                        >
                          <i className="fa fa-filter"></i>
                        </div>
                      </div>
                    </div>

                    {this.state.itensBkp.length > 0 && (
                      <div
                        className="row"
                        style={{ marginBottom: "16px", padding: "0px 15px" }}
                      >
                        <div className="col-5 pd-pedido">
                          <div style={{ position: "absolute", padding: "6px" }}>
                            <i
                              className="fa fa-search"
                              style={{
                                color: "#7ED321",
                                fontSize: "20px",
                              }}
                            ></i>
                          </div>
                          <input
                            className="form-control font-size-13"
                            type="text"
                            placeholder="Para filtrar digite código ou descrição do item"
                            style={{ padding: ".375rem 2.10rem" }}
                            value={this.state.busca}
                            onChange={(e) =>
                              this.onChangeQueryBusca(e.target.value)
                            }
                            disabled={
                              this.state.itensBkp.length === 0 ? true : false
                            }
                          />{" "}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="container-itens-historico">
                    <div className="container card">
                      {this.state.exibirLoading && (
                        <div id="loading-bar-spinner" className="spinner">
                          <div className="spinner-icon"></div>
                        </div>
                      )}

                      <div className="itens-historico">
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead className="thead-dark">
                              <tr>
                                <th scope="col">Item</th>
                                <th scope="col" className="text-right">
                                  Qtd
                                </th>
                                <th scope="col" className="text-right">
                                  Preço
                                </th>
                                <th scope="col" className="text-right">
                                  Preço Total
                                </th>
                                <th scope="col" className="text-right">
                                  Nota
                                </th>
                                <th scope="col" className="text-center">
                                  Emissão
                                </th>
                                <th scope="col" className="text-center">
                                  Ações
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.itens.length > 0 &&
                                this.state.itens.map((item, index) => (
                                  <tr>
                                    <td style={{ fontWeight: "bold" }}>
                                      # {item.cod} - {item.desc}
                                    </td>
                                    <td className="text-right">
                                      {item.qtd} {item.unid}
                                    </td>
                                    <td className="text-right">
                                      R$ {formatarReal(item.precoUnit)}
                                    </td>
                                    <td className="text-right">
                                      R$ {formatarReal(item.precoTotal)}
                                    </td>
                                    <td className="text-right">
                                      {item.nrNota} Seq: {item.seq}
                                    </td>
                                    <td className="text-center">
                                      <img
                                        className="img-responsive"
                                        src={"../images/calendar.svg"}
                                        alt="calendar"
                                        style={{
                                          width: "15px",
                                          marginTop: "-4px",
                                        }}
                                      />{" "}
                                      {moment(item.dtEmissao).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td>
                                      <i className="fa fa-search" style={{cursor:"pointer"}} onClick={() => this.gerarDanfe()}></i>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>

                        {/* <InfiniteScroll
                          dataLength={this.state.itens.length}
                          next={() => this.filtrar(false)}
                          hasMore={this.state.hasMore}
                        >
                          {this.state.itens.length > 0 &&
                            this.state.itens.map((item, key) => (
                              <React.Fragment key={key}>
                                <div className="item-historico">
                                  <div className="item-titulo">
                                    # {item.cod}
                                  </div>

                                  <div className="item-descricao">
                                    {item.desc}
                                  </div>

                                  <div className="d-flex flex-wrap float-left width-100">
                                    <div className="col-6 item-valor-qtd no-padding">
                                      {item.qtd} {item.unid} x R${" "}
                                      {formatarReal(item.precoUnit)}
                                    </div>

                                    <div
                                      className="col-6 item-valor-total no-padding"
                                      style={{ textAlign: "right" }}
                                    >
                                      R$ {formatarReal(item.precoTotal)}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="item-historico"
                                  style={{ borderTop: "none", marginTop: 0 }}
                                >
                                  <div className="d-flex flex-wrap width-100 float-left">
                                    <div className="col-5 no-padding">
                                      Nota {item.nrNota}
                                    </div>
                                    <div className="col-2 no-padding text-center">
                                      Seq. {item.seq}
                                    </div>
                                    <div
                                      className="col-5 float-left width-100 no-padding"
                                      style={{ textAlign: "right" }}
                                    >
                                      <img
                                        className="img-responsive"
                                        src={"../images/calendar.svg"}
                                        alt="calendar"
                                        style={{
                                          width: "15px",
                                          marginTop: "-4px",
                                        }}
                                      />{" "}
                                      {moment(item.dtEmissao).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                        </InfiniteScroll> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HistoricoVenda;
